/* Truestone Diamonds theme scripts */

document.addEventListener('DOMContentLoaded', function () {

  /* Mobile menu */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Product gallery thumbnails */
  var mainImage = document.querySelector('[data-main-image]');
  var thumbs = document.querySelectorAll('[data-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImage) return;
      mainImage.src = thumb.getAttribute('data-full');
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* Product tabs */
  var tabsWrap = document.querySelector('[data-tabs]');
  if (tabsWrap) {
    var tabButtons = tabsWrap.querySelectorAll('[data-tab]');
    var panels = tabsWrap.querySelectorAll('[data-panel]');
    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');
        tabButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === target);
        });
      });
    });
  }

  /* Variant selection: match chosen options to a variant, update price and id */
  var form = document.querySelector('.product-form');
  var variantJson = document.querySelector('[data-variant-json]');
  if (form && variantJson) {
    var variants = [];
    try { variants = JSON.parse(variantJson.textContent); } catch (e) { variants = []; }

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');

    function formatMoney(cents) {
      return '\u00A3' + (cents / 100).toLocaleString('en-GB', { minimumFractionDigits: 2 });
    }

    function selectedOptions() {
      var values = [];
      form.querySelectorAll('.product-form__option').forEach(function (wrap) {
        var select = wrap.querySelector('select[data-variant-option]');
        if (select) { values.push(select.value); return; }
        var checked = wrap.querySelector('input[type="radio"][data-variant-option]:checked');
        if (checked) { values.push(checked.value); }
      });
      return values;
    }

    function onOptionChange() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
    }

    form.querySelectorAll('[data-variant-option]').forEach(function (el) {
      el.addEventListener('change', onOptionChange);
    });
  }

  /* Collection sort */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
});
